import { render, staticRenderFns } from "./workout-pt-tabs.vue?vue&type=template&id=0fc335d3&"
import script from "./workout-pt-tabs.vue?vue&type=script&lang=js&"
export * from "./workout-pt-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports